
export const CHECKS = '/checks';
export const CHECK = id => `${CHECKS}/${id}`;

export const INCOMES = '/incomes';
export const INCOME = id => `${INCOMES}/${id}`;

export const PROFILES = '/profiles';
export const PROFILE = id => `${PROFILES}/${id}`;

export const TACS = '/tac';
export const TAC = id => `${TACS}/${id}`;

export const REPORTEMAIL = '/resultEmail';
export const REPORT = id => `${REPORTEMAIL}/${id}`;

export const SUPPORTEMAIL = '/supportEmail';
export const SUPPORT = id => `${SUPPORTEMAIL}/${id}`;

export const LEADS = '/leads';
export const LEAD = id => `${LEADS}/${id}`;

export const RERUNS = '/rerun';
export const RERUN = id => `${RERUNS}/${id}`;



// WEBPACK FOOTER //
// ./src/endpoints.js